require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-wfcu-expands-board-with-new-member.json") })
        }
      }, "path---es-articles-wfcu-expands-board-with-new-member");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-wfcu-expands-board-with-new-member!./.cache/json/es-articles-wfcu-expands-board-with-new-member.json
// module id = 2477
// module chunks = 231608221292675